import { render } from "./TheCategories.vue?vue&type=template&id=470af8a8&scoped=true"
import script from "./TheCategories.vue?vue&type=script&lang=js"
export * from "./TheCategories.vue?vue&type=script&lang=js"

import "./TheCategories.vue?vue&type=style&index=0&id=470af8a8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470af8a8"]])

export default __exports__